import { render, staticRenderFns } from "./content-list.vue?vue&type=template&id=42455d68&scoped=true&"
import script from "./content-list.vue?vue&type=script&lang=js&"
export * from "./content-list.vue?vue&type=script&lang=js&"
import style0 from "./content-list.vue?vue&type=style&index=0&id=42455d68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42455d68",
  null
  
)

export default component.exports